"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ListedPropertyTypesFilter = void 0;
var _node = require("@domain-group/fe-allhomes-library/lib/node");
var _multiValueSearchQueryField = require("../multi-value-search-query-field");
var _parseSlugs = require("../../utils/parse-slugs");
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
class ListedPropertyTypesFilter extends _multiValueSearchQueryField.MultiValueSearchQueryField {
  get validListingTypes() {
    return ['RENTAL_RESIDENTIAL'];
  }
  constructor(searchOptions, values) {
    super(searchOptions, Object.values(_node.RentalType), values, [..._node.RentalTypeKeys]);
    _defineProperty(this, "urlSlug", ListedPropertyTypesFilter.urlSlug);
  }
  static fromUrlParameters(searchOptions, q) {
    return new ListedPropertyTypesFilter(searchOptions, (0, _parseSlugs.parseSlugs)(_node.RentalType, q.listingtypes));
  }
}
exports.ListedPropertyTypesFilter = ListedPropertyTypesFilter;
_defineProperty(ListedPropertyTypesFilter, "urlSlug", 'listingtypes');